import React from "react";
import { Link } from 'react-scroll';

export default function Home() {
  return (
    <div id="home" class="h-screen relative">
      <div class="h-full flex flex-col">
        <div class="h-3/4 flex items-center justify-center mb-8">
          <div class="h-full basis-1/2 relative">
            <img class="h-full" src={`${process.env.PUBLIC_URL}/images/home.jpg`} alt=""></img>
            <div class="bg-white z-10 absolute top-1/2 left-1/3 -translate-y-1/2 w-full px-6 py-5">
              <div class="mb-6">
                <span class="text-primary text-2xl uppercase">Wedding and Event Planner</span>
              </div>
              <div class="flex flex-col">
                <span class="text-primary text-base">you do the dreaming,</span>
                <span class="text-primary text-base">we do the planning</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mx-auto">
          <Link to="contact" smooth={true} offset={-75}>
            <button class="inline-flex bg-button py-4 px-8 rounded-full">
              <span class="uppercase text-primary text-xs">
                Let's plan your big day!
              </span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
